import type { EmailGreetingBreakpoints } from '../stores/useSettingsStore'

export type EmailGreeting = 'Good morning,' | 'Good afternoon,' | 'Good evening,'

export function getEmailGreeting(date: Date, breakpoints: EmailGreetingBreakpoints): EmailGreeting {
  const minutes =
    date.getHours() * 60 +
    date.getMinutes() +
    date.getSeconds() / 60 +
    date.getMilliseconds() / 60000

  if (minutes >= breakpoints.morningStart && minutes < breakpoints.afternoonStart) {
    return 'Good morning,'
  }

  if (minutes >= breakpoints.afternoonStart && minutes <= breakpoints.eveningStart) {
    return 'Good afternoon,'
  }

  return 'Good evening,'
}
